import classNames from 'classnames'
import React from 'react'
import { ButtonConfigurationItem } from './ButtonConfigurationItem'
import { RemoteButtonControls, TabButtons } from './ButtonConfigurationScreen'
import HoverExtraInformation from '../components/HoverExtraInformation'
import './ButtonConfigurationGroup.scss'

export interface ButtonConfigurationGroupProps {
  subcategoryGroup: TabButtons
  expandableContent: React.ReactNode
  fixedContent: React.ReactNode
  isButtonsSection: boolean
  remoteButtonControls: RemoteButtonControls
  titleShown: boolean
}

export const ButtonConfigurationGroup: React.FC<ButtonConfigurationGroupProps> = (props) => {

  const { titleShown, subcategoryGroup, expandableContent, fixedContent, isButtonsSection, remoteButtonControls } = props

  return (
    <React.Fragment>
      {titleShown && (
        <div
          style={{
            marginTop: '20px',
          }}
        >
          { expandableContent ? (
            <HoverExtraInformation
              collapsible
              label="i"
              title={(
                <h4>{subcategoryGroup.title}</h4>
              )}
            >
              {expandableContent}
            </HoverExtraInformation>
          ) : (
            <h4>{subcategoryGroup.title}</h4>
          )}
          {fixedContent}
        </div>
      )}

      {subcategoryGroup.subtitle !== null && (
        <h5 className={classNames('buttonOptionGroupSubtitle', { firstSubtitle: titleShown })}>
          {subcategoryGroup.subtitle}
        </h5>
      )}

      <div className={classNames('ButtonOptionGroup', { largeCells: !isButtonsSection })}>
        {subcategoryGroup.items.map((item, it) => {

          return (
            <ButtonConfigurationItem
              key={`configitem-${item.interfaceProduct.itemNo}-${item.mechOptions[0]?.itemNo ?? ''}`}
              item={item}
              isButtonsSection={isButtonsSection}
              remoteButtonControls={remoteButtonControls}
            />
          )
        })}
      </div>
    </React.Fragment>
  )
}